import React, { Component } from 'react';
import { Button, Container, Col, Row, Form } from 'react-bootstrap'
import { connect } from "react-redux";
import TextField from "../common/form/TextField.js";

import { LOADING_STATUES } from "../constants/constants";

const mapStateToProps = state => {
  return {
    currentUser: state.currentUserReducer
  };
}

const matchDispatchToProps = (dispatch) => {
  return {
    handleLockout: (lockout) => dispatch({ type: 'SET_LOCKOUT_IN_PLACE', lockout })
  }
}

class AlertEntryEmailRow extends Component {

  state = {
    selectedId: '',
    selectedAlertName: '',
    showDeleteConfirmationDialog: false,
    loadingStatus: "",
    errors: {}
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: ""
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message
      })
    }
  }

  render() {

    let disableField = this.props.emailAddress.saved;

    let verifiedBadge = <span></span>;
    let resendButton =  <></>;
    let resendMessage = 'To modify a recipient, remove the recipient and add a new one.'
    if (disableField) {
      if (this.props.emailAddress.verified === true) {
        verifiedBadge = <span className='badge bg-success-darker text-light'>Email Verified</span>;
		// The below button is for testing only.  Should be removed before production.
        // resendButton = <Button key={'emailResend' + this.props.index} variant="secondary" id={'emailResend' + this.props.index} onClick={this.props.onResend}>Test Resend</Button>;
      } else {
        verifiedBadge = <span className='badge bg-warning text-dark'>Verification Needed</span>;
        resendButton = <Button key={'emailResend' + this.props.index} variant="secondary" id={'emailResend' + this.props.index} onClick={this.props.onResend}>Resend</Button>;
        resendMessage = 'Click Resend to recieve the verification email again.  To modify a recipient, remove the recipient and add a new one.'
      }
    }

    return (
      <>
        <fieldset className="borderthick p-2 field_set" name={this.props.alertName} style={{ marginRight: 10 }} >
          <legend className="float-none w-auto" style={{ fontSize: '1rem', margin: 0, }} >Email Recipient {this.props.index + 1}</legend>
          <Row style={{ paddingBottom: 10 }}>
            <Col style={{ paddingLeft: 0 }} lg={12} md={12} sm={12} xs={12}>
              <Container name={this.props.alertName}>
                <Row>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    {verifiedBadge}
                  </Col>
                  <Col className='text-right' style={{ padding: 0 }} lg={6} md={6} sm={6} xs={6}>
                    <Button variant="link" key={'emailDelete' + this.props.index} id={'emailDelete' + this.props.index} style={{ paddingTop: 0 }} onClick={this.props.onDelete}>Remove</Button>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6} sm={9} xs={9}>
                    <Form.Group controlId={'emailEntry' + this.props.index} style={{ marginBottom: 0 }} >
                      <TextField formGroup={{ label: 'Email Address', fieldType: 'email', value: this.props.emailAddress.value, primaryCriteria: true, placeholder: ' ', disableField }} onChange={this.props.onChange} />
                      <div style={{ color: "red", fontWeight: "bold" }}> {this.props.errors['email' + this.props.index]}</div>
                    </Form.Group>
                  </Col>
                  <Col style={{ paddingLeft: 0 }} lg={3} md={3} sm={2} xs={2}>
                    <div>&nbsp;</div>
                    {
                      !disableField &&
                      <Button key={'emailLookup' + this.props.index} variant="primary" id={'emailLookup' + this.props.index} onClick={this.props.onClick}>Lookup</Button>
                    }
                    { resendButton }
                  </Col>
                </Row>
                <Row>
                  {
                    !disableField &&
                    <Col style={{ fontSize: '0.875em', marginLeft: 3 }} >
                      Enter an email address or look up a previously used one.
                    </Col>
                  }
                  {
                    disableField &&
                    <Col style={{ fontSize: '0.875em', marginLeft: 3 }} >
                      {resendMessage}
                    </Col>
                  }
                </Row>
                <Row>&nbsp;</Row>
                {
                  !disableField &&
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      {/* checkbox is tricky.  This is the only way I could make the checked attribute works.  It's essentially forcing the checkbox to re-render. */}
                      {
                        this.props.emailAddress.acknowledged && 
                        <Form.Check key={'emailAcknowledgeChecked' + this.props.index} id={'emailAcknowledge' + this.props.index} type='checkbox' checked={true} onChange={this.props.onChange} label={this.props.acknowledgement} />
                      }
                      {
                        !this.props.emailAddress.acknowledged && 
                        <Form.Check key={'emailAcknowledgeUnchecked' + this.props.index} id={'emailAcknowledge' + this.props.index} type='checkbox' checked={false} onChange={this.props.onChange} label={this.props.acknowledgement} />
                      }
                      <div style={{ color: "red", fontWeight: "bold" }}> {this.props.errors['emailAcknowledged' + this.props.index]}</div>
                    </Col>
                  </Row>
                }
              </Container>
            </Col>
          </Row>
        </fieldset>

      </>
    )
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(AlertEntryEmailRow);